module.exports = __webpack_public_path__ + "static/img/management.fcee061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/management.png
// module id = apa3
// module chunks = 0